<script setup>
import { IonPage, modalController, actionSheetController } from "@ionic/vue";
import { computed, ref } from "vue";
import store from "@/js/store";
import http from "@/js/http";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import { alertModal } from "@/main";
import MessageDialog from "@/views/listening/components/MessageDialog.vue";

const listenStore = useListenConfigStore();

const theme = computed(() => listenStore.theme);

const backHome = () => {
  modalController.dismiss('back');
};

const endStudy = () => {
  modalController.dismiss()
  openConfirmModal();
};

// 询问是否创建抗遗忘
async function openConfirmModal() {
  const modal = await modalController.create({
    component: MessageDialog,
    componentProps: {
      message: "本次课程学习已结束，是否创建抗遗忘？",
      type: "hasCancel",
    },
    cssClass: "center_modal_controller_class_message",
    backdropDismiss: false,
  });
  await modal.present()
  const { data } = await modal.onDidDismiss();
  if (data === "confirm") {
    let aptmId = store.getAppointment().aptmId;
    showTeacherSelect(aptmId);
  } else {
    modalController.dismiss();
    backHome();
  }
}

//显示选择资料列表
async function showTeacherSelect(aptmId) {
  return new Promise(async (resolve) => {
    let buttons = [];
    for (let i = 5; i < 24; i++) {
      let fill = i < 10 ? "0" : "";
      let time1 = fill + i + ":00";
      let time2 = fill + i + ":30";
      let params1 = { aptmId: aptmId, startTime: time1 };
      let params2 = { aptmId: aptmId, startTime: time2 };
      buttons.push({
        text: time1,
        handler: async () => {
          await requestGenerateForget(params1);
          resolve();
        },
      });

      buttons.push({
        text: time2,
        cssClass: "teacherSelectButtons",
        handler: async () => {
          await requestGenerateForget(params2);
          resolve();
        },
      });
    }
    const actionSheet = await actionSheetController.create({
      header: "选择抗遗忘时间 ",
      buttons: buttons,
      backdropDismiss: false,
    });

    await actionSheet.present();
  });
}

const timeout = ref(false);

//创建抗遗忘
function requestGenerateForget(params) {
  return new Promise((resolve, reject) => {
    if (!timeout.value) {
      timeout.value = true;
      setTimeout(() => {
        timeout.value = false;
      }, 500);
      if (params.aptmId == 0) {
        resolve("");
      } else {
        http.post("/forget/generateForget", params).then(async (res) => {
          if (res.data.success) {
            await alertModal("21天抗遗忘创建成功。");
            backHome();
            resolve("");
          }
        }).catch(() => {
           reject("");
         });
      }
    }
  });
}
</script>

<template>
  <ion-page :class="['finish-study-page', theme]">
    <div class="dialog-wrap">
      <img class="trophy" src="@/assets/listening/Trophy.png" alt="" />
      <div class="content-box">
        <img class="finish" src="@/assets/listening/finish.gif" alt="" />
        <div>恭喜完成训练</div>
        <div class="btn-group">
          <div class="back-btn btn" @click="backHome">回到目录页</div>
          <div class="end-btn btn" @click="endStudy">
            结束训练
            <img class="forget" src="@/assets/listening/create-forget.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<style scoped lang="less">
@import "ThemeTag/listenTheme";
.finish-study-page {
  --background: transparent;
  background: transparent;
  overflow: visible;
  contain: none;
}
.dialog-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 5.5rem;
  box-sizing: border-box;
}
.trophy {
  width: 10rem;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: none;
}
.content-box {
  position: relative;
  width: 100%;
  height: 19.5rem;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 11.5rem;
  font-weight: 500;
  background: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  .finish {
    top: -1.5rem;
    width: 13rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    pointer-events: none;
  }
}
.btn-group {
  display: flex;
  gap: 0.68rem;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  .btn {
    width: 8rem;
    height: 2.5rem;
    line-height: 2.4rem;
    border: 1px solid #ccc;
    color: #333;
    font-size: 1rem;
    border-radius: 1.4rem;
  }
  .end-btn {
    background-color: var(--button-bg-color);
    border: 1px solid var(--button-bg-color);
    color: white;
    position: relative;
    .forget {
      width: 5.4rem;
      height: 2.6rem;
      position: absolute;
      top: -1.4rem;
      right: 0;
    }
  }
}
</style>
<style>
.center_modal_controller_class_finish_study {
  --height: 25rem;
  --max-height: 25rem;
  --min-height: 25rem;
  --background: transparent;
  --box-shadow: none;
  --overflow: visible;
}
.center_modal_controller_class_finish_study::part(content) {
  background: transparent;
  box-shadow: none;
  overflow: visible;
  border-radius: 0;
}
.center_modal_controller_class_finish_study .ion-page,
.center_modal_controller_class_finish_study .finish-study-page {
  overflow: visible !important;
  contain: none !important;
  background: transparent;
}
</style>
